import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const fetchUserPersonal = async ({ auth, onSuccess=null, onError=null }) => {
    try {
        const url = `${BACKEND_API_URL}/users/personal`;

        const response = await fetchWithAuth(
            url,
            { 
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchUserPersonal");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const updateUserPersonal = async ({auth, payload, onSuccess = null, onError = null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/personal`,
            { 
                method: 'PUT',
                body: JSON.stringify(payload)
            },
            auth
        );

        const data = await handleApiResponse(response, "updateUserPersonal");

        if (onSuccess) onSuccess(data);
        return data;

    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const fetchUsers = async ({ auth, authorityType=null, email=null, onSuccess=null, onError=null }) => {
    try {
        const params = new URLSearchParams();
        if (authorityType) params.append("authorityType", authorityType);
        if (email) params.append("email", email);

        const url = `${BACKEND_API_URL}/users${params.toString() ? `?${params.toString()}` : ""}`;

        const response = await fetchWithAuth(
            url,
            { 
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchUsers");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const fetchUserDetailed = async ({ auth, userId, onSuccess=null, onError=null }) => {
    try {
        if (!userId) return null;

        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/detailed/${userId}`,
            { 
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchUsers");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const createUser = async ({auth, payload, onSuccess = null, onError = null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users`,
            { 
                method: 'POST',
                body: JSON.stringify(payload)
            },
            auth
        );

        const data = await handleApiResponse(response, "createUser");

        if (onSuccess) onSuccess(data);
        return data;

    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const updateUser = async ({auth, userId, payload, onSuccess = null, onError = null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/${userId}`,
            { 
                method: 'PUT',
                body: JSON.stringify(payload)
            },
            auth
        );

        const data = await handleApiResponse(response, "updateUser");

        if (onSuccess) onSuccess(data);
        return data;

    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const fetchUserReferences = async ({ auth, userId, onSuccess=null, onError=null }) => {
    try {
        if (!userId) return null;

        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/references/${userId}`,
            { 
                method: 'GET'
            },
            auth
        );

        const data = await handleApiResponse(response, "fetchUserReferences");

        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const deleteUser = async ({auth, userId, onSuccess=null, onError=null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/${userId}`,
            { method: 'DELETE' },
            auth
        );

        const data = await handleApiResponse(response, "deleteUser");
        
        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}

export const deleteUserPersonal = async ({auth, onSuccess=null, onError=null}) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/users/personal`,
            { method: 'DELETE' },
            auth
        );

        const data = await handleApiResponse(response, "deleteUserPersonal");
        
        if (onSuccess) onSuccess(data);
        return data;
    }
    catch (error) {
        if (onError) {
            onError(error);
            return
        }
        throw error;
    }
}
